export const getStatusColor = (name: string) => {
  if (name === "Ready") {
    return "#93AAFD";
  }
  if (name === "In Progress") {
    return "#FFD80B";
  }
  if (name === "Waiting") {
    return "#F15252";
  }
  if (name === "Completed") {
    return "#47DE96";
  }
  return "#000";
};

/**
 * Top of the "Select status" menu (fixed position): below the trigger when the
 * full menu fits there, otherwise above it when there is more room above
 * (QA batch 16, HOME-020). Called again when the menu's height changes
 * (its statuses load after it opens).
 */
export const menuLookTop = (
  trigger: { top: number; bottom: number },
  menuHeight: number,
  viewportHeight: number,
) => {
  const height = Math.max(menuHeight, 0);
  const below = trigger.bottom + 4;
  const roomBelow = viewportHeight - 8 - below;
  const roomAbove = trigger.top - 4 - 8;
  if (height <= roomBelow || roomBelow >= roomAbove) return below;
  return Math.max(8, trigger.top - 4 - height);
};
